import {
  RmaLgmCommodityCode,
  RmaLgmCommodityCodes,
} from '../lgm/LgmCommodities';
import { RmaLrpCommodityCode, RmaLrpCommodityCodes } from './LrpCommodities';

export const CoverageTiers = {
  ALL: 'ALL',
  TOP: 'TOP',
} as const;
export type CoverageTier = (typeof CoverageTiers)[keyof typeof CoverageTiers];

export const COVERAGE_LEVEL_PRECISION_FOR_COMPARISONS = 4; // Note: RMA Files provide a 6 decimal precision, but we use 4 for comparisons for historical reasons
export const COVERAGE_LEVEL_PRECISION_FOR_STORING = 6;
export const lrpNumberOfHeadParameters: Record<
  RmaLrpCommodityCode | RmaLgmCommodityCode | '',
  {
    limit: number;
    helperText: string;
  }
> = {
  [RmaLrpCommodityCodes.SWINE]: {
    limit: 70000,
    helperText: 'Swine max limit is 70,000',
  },
  [RmaLrpCommodityCodes.FED_CATTLE]: {
    limit: 12000,
    helperText: 'Fed Cattle max limit is 12,000',
  },
  [RmaLrpCommodityCodes.FEEDER_CATTLE]: {
    limit: 12000,
    helperText: 'Feeder Cattle max limit is 12,000',
  },
  [RmaLgmCommodityCodes.CATTLE]: {
    limit: 0,
    helperText: 'Cattle is not supported',
  },
  [RmaLgmCommodityCodes.DAIRY_CATTLE]: {
    limit: 0,
    helperText: 'Dairy Cattle is not supported',
  },
  '': {
    limit: 0,
    helperText: '',
  },
};
